import { computed, ref, type Ref, type ComputedRef } from "vue";
import {
  trackPinSessionEscapeHatchClicked,
  trackPinSessionEscapeHatchConfirmed,
  trackPinSessionEscapeHatchDismissed
} from "../transfersPinningAnalytics";

const TRIGGER_TYPE = "transfers";

type Pin = {
  id: string;
  isNew?: boolean;
  messages?: unknown[];
};

type PinningPanel = {
  activePin: ComputedRef<Pin | null>;
  pins: Ref<Pin[]>;
};

type EscapeHatchOptions = {
  onConfirm: () => void;
};

type EscapeHatchReturn = {
  escapeHatchModalOpen: Ref<boolean>;
  handleEscapeHatchClick: () => void;
  handleEscapeHatchConfirm: () => void;
  handleEscapeHatchDismiss: () => void;
};

export function useEscapeHatch(
  panel: PinningPanel,
  { onConfirm }: EscapeHatchOptions
): EscapeHatchReturn {
  const escapeHatchModalOpen = ref(false);

  const activePin = computed(() => panel.activePin.value);

  function buildEventPayload() {
    return {
      triggerType: TRIGGER_TYPE,
      pinCount: panel.pins.value.length,
      messageCount: activePin.value?.messages?.length ?? 0
    };
  }

  function handleEscapeHatchClick() {
    trackPinSessionEscapeHatchClicked(buildEventPayload());
    escapeHatchModalOpen.value = true;
  }

  function handleEscapeHatchConfirm() {
    trackPinSessionEscapeHatchConfirmed(buildEventPayload());
    escapeHatchModalOpen.value = false;
    onConfirm();
  }

  function handleEscapeHatchDismiss() {
    trackPinSessionEscapeHatchDismissed(buildEventPayload());
    escapeHatchModalOpen.value = false;
  }

  return {
    escapeHatchModalOpen,
    handleEscapeHatchClick,
    handleEscapeHatchConfirm,
    handleEscapeHatchDismiss
  };
}
